<template>
  <Main>
    <BackButton text="Back to Project" :route="$routes.project(project.id)" />

    <v-container style="max-width: 90%">
      <v-row>
        <v-col>
          <h1>
            {{ project.name }} - KPIs
          </h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
              :headers="tableFieldKpis"
              :items="kpis"
              item-key="id"
              :items-per-page="10"
              :hide-default-footer="kpis.length <= 10"
              class="elevation-3"
          >
            <template v-slot:item.name="{ item }">
              <b>{{ item.name }}</b> <v-chip v-if="item.likert" size="small">Likert Scale</v-chip>
            </template>

            <template v-slot:item.action="{ item }">

                <!-- EDIT BUTTON -->
                <v-tooltip :text="`Edit KPI '${item.name}'`" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn
                        v-bind="props"
                        class="mr-5 border-md"
                        size="small"
                        rounded
                        flat
                        height="35px"
                        min-width="35px"
                        max-width="35px"
                        @click.prevent="onEditKpi(item.id)"
                        @auxclick.prevent="onMiddleClickEditKpi(item.id)"
                    ><i class="fas fa-pen text-blue-darken-4" /></v-btn>
                  </template>
                </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="auto">
          <OverviewUpdateValues method="kpi" :project-id="project.id" :errors="errors"></OverviewUpdateValues>
        </v-col>
      </v-row>

    </v-container>

  </Main>

</template>

<script setup>
import Main from "../../Layouts/Main.vue";
import OverviewUpdateValues from "@/Pages/Projects/subcomponents/OverviewUpdateValues.vue";
import {router} from "@inertiajs/vue3";
import * as $routes from "@/packs/routes";
import StringManipulation from "@/Mixins/StringManipulation";
import {computed} from "vue";
import BackButton from "@/Shared/BackButton.vue";

const props = defineProps({
  project: {
    type: Object,
    required: true
  },

  projectKpis: {
    type: Array,
    required: true
  },

  aggregationLevels: {
    type: Array,
    required: true
  },

  aggregationLevelValues: {
    type: Array,
    required: true
  },

  errors: {
    type: Array,
    required: true
  },

});

const tableFieldKpis = [
  { key: 'id', title: 'ID' },
  { key: 'name', title: 'Name' },
  { key: 'building', title: 'Building' },
  { key: 'peb', title: 'PEB' },
  { key: 'ped', title: 'PED' },
  { key: 'city', title: 'City' },
  { key: 'island', title: 'Island' },
  { key: "action", title: "Actions", align: "center"}
]

const kpis = computed(() => {
  // all project's kpis are retrieved at first
  return props.projectKpis.map((kpi) => {

    // for each one of the kpis, get the agg. levels
    const aggregationValues = props.aggregationLevelValues.filter((agg) => agg.kpi_id === kpi.id);

    // analyze them into nullable values
    const building = aggregationValues.find((agg) => agg.name === 'Building')?.value;
    const peb = aggregationValues.find((agg) => agg.name === 'PEB')?.value;
    const ped = aggregationValues.find((agg) => agg.name === 'PED')?.value;
    const city = aggregationValues.find((agg) => agg.name === 'City')?.value;
    const island = aggregationValues.find((agg) => agg.name === 'Island')?.value;

    // return an object readable for the table
    return {
      ...kpi,
      name: kpi.name,
      building: building === undefined? '-' : building,
      peb: peb === undefined? '-' : peb,
      ped: ped === undefined? '-' : ped,
      city: city === undefined? '-' : city,
      island: island === undefined? '-' : island,
    }
  });
});

function onEditKpi(id) {
  router.get($routes.edit_project_kpi(props.project.id, id));
}

function onMiddleClickEditKpi(id) {
  const route = $routes.edit_project_kpi(props.project.id, id);
  window.open(route, '_blank');
}
</script>

<style scoped>

</style>
